import React from 'react';

const offPageSeoItems = [
  {
    title: 'Web 2.0:',
    desc: 'An SEO strategy used to drive significant referral traffic by publishing and sharing content on interactive blogging platforms.'
  },
  {
    title: 'Press Release:',
    desc: 'Increases the website visibility and attracts more traffic. It promotes your products or services through newsworthy announcements.'
  },
  {
    title: 'Local Directory:',
    desc: 'Helps attract nearby customers and improve engagement by listing your business in region-specific directories.'
  },
  {
    title: 'Guest Blogging:',
    desc: 'Strengthens connections with other bloggers and brings new visitors to your site through content contributions on external blogs.'
  },
  {
    title: 'Classifieds:',
    desc: 'Increases the visibility and draws more traffic. It promotes products, services, or websites.'
  },
  {
    title: 'Broken Link Building:',
    desc: 'Involves finding broken links on other sites and suggesting your content as a replacement to reclaim lost traffic and backlinks.'
  },

];

function OffPageSeoScrollSection() {
  return (
    <section className="offpage-seo-scroll-section">
      <div className="container offpage-seo-container">
        {/* Left Column: Image Showcase */}
        <div className="offpage-seo-left">
          <div className="offpage-seo-img-wrapper">
            <img
              src="/assets/images/seo-services/seo-img2.jpg"
              alt="Off-page SEO and Link Authority"
              className="offpage-seo-img"
            />
          </div>
        </div>

        {/* Right Column: Scrollable Off-page SEO Content */}
        <div className="offpage-seo-right">
          <h2 className="offpage-seo-title">Off-page SEO</h2>

          <div className="offpage-seo-scroll-box">
            {offPageSeoItems.map((item, index) => (
              <div key={index} className="offpage-seo-item">
                <h3 className="offpage-seo-item-title">{item.title}</h3>
                <p className="offpage-seo-item-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OffPageSeoScrollSection;
